export default __webpack_public_path__ + "static/media/transfer-receive-step2.35d86493.png";